import { render, staticRenderFns } from "./ModifyTable.vue?vue&type=template&id=ca70d6bc&scoped=true"
import script from "./ModifyTable.vue?vue&type=script&lang=js"
export * from "./ModifyTable.vue?vue&type=script&lang=js"
import style0 from "./ModifyTable.vue?vue&type=style&index=0&id=ca70d6bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca70d6bc",
  null
  
)

export default component.exports